const ICON_SETS = [
  'Ion',
  'Material',
  'Feather',
  'FontAwesome',
  'Remix',
] as const;

export { ICON_SETS };
